import { RadioButtonRoot } from "./RadioButton.styles";
import { RadioButtonProps } from "./RadioButton.types";
import { cx } from "../../react-utils";
import { RadioCheckedIcon, RadioUncheckedIcon } from "../assets/icons";
import { Label } from "../Label";
import { FormControl } from "../FormControl";
import { useMergeDefaultProps } from "../../react-components-core";
import { useRef } from "react";

export default function RadioButton(props: RadioButtonProps) {
    const {
        defaultValue = false,
        icon = <RadioUncheckedIcon />,
        checkedIcon = <RadioCheckedIcon />,
        disabled = false,
        LabelProps = {},
        hideError = true,
        Label: LabelProp = Label,
        ...rest
    } = useMergeDefaultProps("RadioButton", props);

    const radioButtonRef = useRef<HTMLInputElement>(null);

    const handleClick = () => {
        if (radioButtonRef.current) radioButtonRef.current.click();
    };

    return (
        <FormControl<boolean>
            Label={[LabelProp, { placement: "right", ...LabelProps }]}
            defaultValue={defaultValue}
            disabled={disabled}
            hideError={hideError}
            onClick={handleClick}
            {...rest}
        >
            {(value, setValue) => (
                <RadioButtonRoot
                    className={cx("RadioButton", value && "Checked", disabled && "Disabled")}
                    onClick={() => setValue(!value)}
                    role="radio"
                    aria-checked={value}
                    tabIndex={0}
                    ref={radioButtonRef}
                >
                    {value ? checkedIcon : icon}
                </RadioButtonRoot>
            )}
        </FormControl>
    );
}
